export enum FaqThematicAreaEnum {
  BANDI_INCENTIVI = 'bandi e incentivi',
  RDP = 'rdp',
  BANDI = 'bandi',
  PROFILE = 'user-profile',
  CHANGE_PASSWORD = 'change-password',
}
